import React from "react";
export function Logo() {
  return (
    <svg
      width="94px"
      height="89px"
      viewBox="0 0 94 89"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <title>Logo</title>
      <g
        id="VertexAiPage"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="VertexAILanding"
          transform="translate(-95.000000, -39.000000)"
          fill="#E0565F"
        >
          <g id="Group-3" transform="translate(87.422546, 31.595106)">
            <path
              d="M100.130779,51.5245823 C99.9235715,51.0321403 99.5544596,50.6253116 99.0845934,50.3714951 C98.6251029,50.0737484 98.1087776,49.8748309 97.5683827,49.7873654 C96.6865644,49.6326266 95.7857068,49.6198218 94.899852,49.7494349 L94.8088794,49.7494349 C91.2609465,50.2804619 87.9859316,52.8445636 85.2491714,54.8928106 C84.9156051,55.1355657 84.5972008,55.4010792 84.2712156,55.6514205 C82.9293692,56.6907162 81.617847,57.7603563 80.3139058,58.8375824 C79.5027331,59.5127453 78.6839794,60.1803221 77.8576446,60.8403128 C77.5089162,61.1209985 77.1677688,61.3409953 76.2277182,62.076847 L75.7273687,62.6458045 L76.2277182,62.076847 L75.5833287,62.5851157 C75.7197876,62.2058107 75.8562466,61.8265057 75.9927056,61.4547868 C78.9417352,54.6272971 80.905228,49.0894442 84.4986472,42.5805706 C87.7205947,36.7316877 94.6724204,28.9786938 94.8846899,22.0981013 C94.9321941,20.9905702 94.74086,19.8857856 94.323692,18.8588367 C93.9271986,17.8258365 93.2027557,16.9516621 92.2616455,16.370596 C93.1488319,16.9980201 93.8148971,17.8902388 94.1644899,18.9195255 C94.2554625,19.1622807 93.5428435,17.5085109 94.3843404,19.6781355 C93.9524966,18.4257882 93.2211645,17.29811 92.2540645,16.3933543 C90.5118262,14.8196544 88.2144491,14.0060271 85.8708178,14.1326965 L85.9693715,14.1326965 C86.961712,13.999452 87.9716185,14.1221838 88.903239,14.4892432 C87.9792065,14.092908 86.969449,13.9388632 85.9693715,14.0416633 C85.476603,14.1023521 84.9686724,14.1251104 84.4531608,14.2237297 L83.043085,14.5347598 C82.0954533,14.8457899 81.1099164,15.0733729 80.1850279,15.4754362 L78.7825331,16.0292215 C78.3125078,16.2112879 77.8728067,16.446457 77.4179435,16.6588678 C75.5909097,17.4857526 73.8548486,18.50229 72.1112064,19.488483 C70.3675641,20.4746759 68.639084,21.544316 67.0243197,22.7429198 L64.5453153,24.4422061 L62.1421215,26.2401118 L59.7465087,28.0456035 L57.4115444,29.9345423 C55.8574285,31.1938349 54.2881505,32.4379553 52.787102,33.7655227 L50.512786,35.7227365 L49.3756281,36.7165155 C48.9965754,37.0351317 48.6175227,37.3765062 48.2612132,37.7330529 C42.5375181,43.3391806 37.0260925,49.1577191 31.8482332,55.2645294 C26.670374,61.3713397 21.7654326,67.7664218 18.0658787,74.8821834 C19.0362535,73.1297944 20.1203441,71.3698192 21.2347589,69.6932912 C18.662412,73.511494 16.4782983,77.5776663 14.7150532,81.8310508 C13.6309626,84.584805 12.690912,87.9606194 13.8053268,90.8736817 L13.7067731,90.820579 C13.8357421,91.1691379 13.9929395,91.5065763 14.1767984,91.8295303 C14.7782969,92.8840347 15.6263286,93.7768829 16.6482217,94.4315625 C18.0270201,95.2881239 19.6194642,95.737776 21.2423399,95.7287856 C21.66756,95.7367453 22.0928724,95.7190122 22.5159569,95.6756829 C22.7888748,95.6756829 23.0542116,95.607408 23.3195485,95.5543053 C22.4226251,95.775346 21.4958578,95.8496392 20.5752073,95.7743022 C20.2264788,95.7363717 19.8853314,95.683269 19.536603,95.6301663 C19.1878745,95.5770636 18.8543082,95.4708582 18.5283229,95.3494806 C17.8602775,95.1368035 17.2268828,94.8275625 16.6482217,94.4315625 C17.7959511,95.2730795 19.1453652,95.7964564 20.5600451,95.9487825 C21.9797979,96.0959769 23.4144902,95.9249431 24.7599486,95.4480999 C27.4304795,94.4330894 29.8120391,92.7792128 31.6966122,90.6309265 C33.5830977,88.5270899 35.3136462,86.2883028 36.8744715,83.9324004 C38.4715467,81.6059965 39.954906,79.2062603 41.3245496,76.7331918 C42.6815581,74.2601232 43.9096888,71.7263659 45.2818594,69.2836418 C46.6657,66.8484103 48.226548,64.5182574 49.9517881,62.3120161 C51.6660551,60.0924526 53.5168925,57.9819548 55.4935379,55.992795 C56.4836845,54.9994944 57.5263105,54.0599999 58.6169318,53.178352 C59.1248624,52.7838748 59.640374,52.419742 60.1786287,52.0328509 C60.6031677,51.7900958 61.0277067,51.5549267 61.4598267,51.350102 L61.4598267,51.350102 L62.1345405,51.046658 C61.0580309,54.164545 60.0421698,57.1989849 59.071795,60.1651499 C56.8657193,66.555329 55.3732726,73.1702257 54.6217168,79.8890093 L55.0386747,79.6159097 L54.6217168,79.8890093 C54.5155821,80.9889937 54.4321905,82.1041504 54.3791231,83.2344793 C54.2729884,85.6696173 54.5459063,89.3868062 56.0014685,91.9281496 C55.7714662,91.5781521 55.5855843,91.2010447 55.4480516,90.8054068 C55.6787404,91.5370099 56.0610624,92.2116887 56.5700475,92.7853789 C57.0273064,93.383079 57.6128033,93.8704538 58.2833655,94.2115656 C58.503216,94.317771 58.7230665,94.4163903 58.9504981,94.5074235 L59.2537403,94.621215 L59.352294,94.621215 C59.7761198,94.7842248 60.2121141,94.9135882 60.6562351,95.0081061 C61.8142971,95.2615319 63.0086939,95.3026568 64.1814248,95.1294837 C65.348793,94.8657208 66.4437018,94.3476887 67.3882103,93.6122637 C69.2299839,92.123967 70.7997911,90.3272407 72.0278148,88.3019939 C72.6722043,87.3158009 73.2635264,86.3068497 73.8321054,85.267554 C74.4006844,84.2282583 74.9237771,83.1889627 75.5226803,82.2331141 C77.9449506,78.2833595 80.563705,74.4576862 83.3690702,70.7705174 C84.7704437,68.9266279 86.2898428,67.1756218 87.9177021,65.5285224 C89.4339127,64.0113025 90.904637,62.4940825 92.466334,61.0754819 C92.4720191,62.5717593 92.5911307,64.0654493 92.8226435,65.5436946 C92.9570957,66.392445 93.1573343,67.2294416 93.4215467,68.0471075 C93.677617,68.8814768 94.063971,69.6700611 94.5662857,70.3836263 L94.9908247,70.9601698 L94.9908247,70.2015599 C94.988351,69.8440869 95.008608,69.4868186 95.0514731,69.1319198 C95.6427952,66.7650567 95.9915237,65.7333471 96.5676837,63.973372 C96.9239932,62.8582153 97.325789,61.7658169 97.7806522,60.6734186 C97.9474354,60.3092858 98.1217996,59.9148086 98.2961638,59.5961924 C99.2043638,57.9267167 99.8778561,56.139753 100.297562,54.2859226 C100.502228,53.3680681 100.444427,52.4110892 100.130779,51.5245823 L100.130779,51.5245823 Z M59.7347263,80.2768411 L59.9653212,80.1231112 L59.7347263,80.2768411 Z M59.7518074,80.2640303 L59.9482401,80.135922 L59.7518074,80.2640303 Z M60.0208348,80.0889489 L59.6792127,80.3110033 L60.0208348,80.0889489 Z M59.961051,80.1145706 L59.7389966,80.2853817 L59.961051,80.1145706 Z M100.432995,60.0454729 C100.617103,58.8425781 100.903492,57.3870753 101.143855,55.8834567 C101.189882,55.594762 101.230795,55.3060672 101.271708,55.0053435 C101.056353,56.7729739 100.770395,58.4887265 100.417653,60.1296755 L100.432995,60.0454729 Z"
              id="Shape"
              fillRule="nonzero"
            ></path>
            <g
              id="Group-2"
              transform="translate(27.675572, 27.675572) rotate(45.000000) translate(-27.675572, -27.675572) translate(15.866174, 0.345801)"
            >
              <path
                d="M11.3261993,-1.13933247e-14 L15.4237322,4.09753285 C9.47071273,10.0505523 5.79839555,18.284274 5.79839555,27.329771 C5.79839555,36.3752681 9.47071273,44.6089897 15.4237322,50.5620092 L11.3261993,54.659542 C4.32946867,47.6628114 4.50509571e-14,37.9988188 4.50509571e-14,27.329771 C4.50509571e-14,16.6607232 4.32946867,6.99673063 11.3261993,-1.13933247e-14 Z M19.521265,8.19506571 L23.6187979,12.2925986 C19.7918568,16.1581956 17.3951866,21.4540635 17.3951866,27.329771 C17.3951866,33.2054785 19.7532008,38.5013464 23.6187979,42.3669435 L19.521265,46.4644763 C14.6119568,41.5551681 11.5967911,34.7903733 11.5967911,27.329771 C11.5967911,19.8691687 14.6119568,13.1043739 19.521265,8.19506571 Z"
                id="Combined-Shape"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export function Facebook() {
  return (
    <svg
      width="8px"
      height="14px"
      viewBox="0 0 8 14"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <title>Facebook</title>
      <g
        id="ProductRecommendationPage"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="ProductRecommendation"
          transform="translate(-181.000000, -815.000000)"
          fill="#FFFFFF"
          fillRule="nonzero"
        >
          <g id="Group-10" transform="translate(167.000000, 804.000000)">
            <g id="facebook-f" transform="translate(14.250000, 11.250000)">
              <path
                d="M6.7565918,7.59375 L7.1315332,5.15056641 L4.78722656,5.15056641 L4.78722656,3.56510742 C4.78722656,2.89669922 5.11470703,2.24516602 6.16464844,2.24516602 L7.23041016,2.24516602 L7.23041016,0.165058594 C7.23041016,0.165058594 6.26326172,0 5.33856445,0 C3.40795898,0 2.14602539,1.17017578 2.14602539,3.28851563 L2.14602539,5.15056641 L0,5.15056641 L0,7.59375 L2.14602539,7.59375 L2.14602539,13.5 L4.78722656,13.5 L4.78722656,7.59375 L6.7565918,7.59375 Z"
                id="Path"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
export function Instagram() {
  return (
    <svg
      width="14px"
      height="14px"
      viewBox="0 0 14 14"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <title>Instagram</title>
      <g
        id="ProductRecommendationPage"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="ProductRecommendation"
          transform="translate(-268.000000, -815.000000)"
          fill="#FFFFFF"
          fillRule="nonzero"
        >
          <g id="Group-10" transform="translate(167.000000, 804.000000)">
            <g id="Group-15-Copy-3" transform="translate(90.000000, 0.000000)">
              <g id="instagram" transform="translate(11.250000, 11.250000)">
                <path
                  d="M6.75301238,3.2887705 C4.837136,3.2887705 3.29178289,4.83412362 3.29178289,6.75 C3.29178289,8.66587638 4.837136,10.2112295 6.75301238,10.2112295 C8.66888876,10.2112295 10.2142419,8.66587638 10.2142419,6.75 C10.2142419,4.83412362 8.66888876,3.2887705 6.75301238,3.2887705 Z M6.75301238,9.00025103 C5.51492246,9.00025103 4.50276135,7.99110231 4.50276135,6.75 C4.50276135,5.50889769 5.51191007,4.49974897 6.75301238,4.49974897 C7.99411469,4.49974897 9.00326342,5.50889769 9.00326342,6.75 C9.00326342,7.99110231 7.99110231,9.00025103 6.75301238,9.00025103 L6.75301238,9.00025103 Z M11.1631429,3.14718844 C11.1631429,3.59603369 10.8016568,3.95450742 10.3558239,3.95450742 C9.90697869,3.95450742 9.54850496,3.59302131 9.54850496,3.14718844 C9.54850496,2.70135557 9.90999107,2.33986946 10.3558239,2.33986946 C10.8016568,2.33986946 11.1631429,2.70135557 11.1631429,3.14718844 Z M13.4555673,3.96655696 C13.4043568,2.88511101 13.1573413,1.92717282 12.3650842,1.13792815 C11.5758396,0.348683477 10.6179014,0.101667968 9.53645543,0.0474450519 C8.42187326,-0.0158150173 5.08113913,-0.0158150173 3.96655696,0.0474450519 C2.8881234,0.0986555841 1.93018521,0.345671092 1.13792815,1.13491576 C0.345671092,1.92416044 0.101667968,2.88209863 0.0474450519,3.96354457 C-0.0158150173,5.07812674 -0.0158150173,8.41886087 0.0474450519,9.53344304 C0.0986555841,10.614889 0.345671092,11.5728272 1.13792815,12.3620719 C1.93018521,13.1513165 2.88511101,13.398332 3.96655696,13.4525549 C5.08113913,13.515815 8.42187326,13.515815 9.53645543,13.4525549 C10.6179014,13.4013444 11.5758396,13.1543289 12.3650842,12.3620719 C13.1543289,11.5728272 13.4013444,10.614889 13.4555673,9.53344304 C13.5188274,8.41886087 13.5188274,5.08113913 13.4555673,3.96655696 Z M12.0156477,10.7293596 C11.7806817,11.3197869 11.3258117,11.7746569 10.732372,12.0126353 C9.84371862,12.3650842 7.73504965,12.2837499 6.75301238,12.2837499 C5.77097512,12.2837499 3.65929376,12.3620719 2.77365279,12.0126353 C2.18322548,11.7776693 1.72835546,11.3227993 1.49037711,10.7293596 C1.13792815,9.84070624 1.21926252,7.73203726 1.21926252,6.75 C1.21926252,5.76796274 1.14094053,3.65628138 1.49037711,2.77064041 C1.72534308,2.1802131 2.1802131,1.72534308 2.77365279,1.48736472 C3.66230615,1.13491576 5.77097512,1.21625014 6.75301238,1.21625014 C7.73504965,1.21625014 9.84673101,1.13792815 10.732372,1.48736472 C11.3227993,1.72233069 11.7776693,2.17720071 12.0156477,2.77064041 C12.3680966,3.65929376 12.2867622,5.76796274 12.2867622,6.75 C12.2867622,7.73203726 12.3680966,9.84371862 12.0156477,10.7293596 Z"
                  id="Shape"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
export function Twitter() {
  return (
    <svg
      width="12px"
      height="11px"
      viewBox="0 0 12 11"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <title>Twitter</title>
      <g
        id="ProductRecommendationPage"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="ProductRecommendation"
          transform="translate(-224.000000, -817.000000)"
          fill="#FFFFFF"
          fillRule="nonzero"
        >
          <g id="Group-10" transform="translate(167.000000, 804.000000)">
            <g id="Group-15-Copy" transform="translate(45.000000, 0.000000)">
              <g id="twitter" transform="translate(12.000000, 13.500000)">
                <path
                  d="M10.7665264,2.42893136 C10.7741436,2.53552553 10.7741436,2.64214313 10.7741436,2.7487373 C10.7741436,6 8.29953242,9.74621776 3.77666319,9.74621776 C2.3832515,9.74621776 1.08884019,9.34264587 0,8.64216657 C0.197977336,8.66499479 0.388314017,8.672612 0.59390857,8.672612 C1.74363962,8.672612 2.80203438,8.28429799 3.64721737,7.6218579 C2.5659944,7.59900625 1.65989711,6.89088629 1.34770839,5.91625749 C1.5,5.9390857 1.65227989,5.95432013 1.81219458,5.95432013 C2.03300013,5.95432013 2.25382912,5.92385127 2.45940023,5.87057762 C1.33249739,5.64213141 0.487290966,4.65229161 0.487290966,3.45685725 L0.487290966,3.42641182 C0.814690682,3.60915472 1.19543436,3.72336611 1.59895937,3.7385771 C0.936519283,3.29694257 0.5025254,2.54314275 0.5025254,1.69034254 C0.5025254,1.23349701 0.624330564,0.81471412 0.837542334,0.449228317 C2.04821113,1.94161696 3.86802292,2.91622233 5.90861683,3.02283993 C5.87055418,2.84009703 5.84770253,2.64976035 5.84770253,2.45940023 C5.84770253,1.10405119 6.94415994,0 8.30710276,0 C9.01522272,0 9.65481115,0.296954285 10.1040629,0.776651471 C10.6598854,0.670057305 11.1928797,0.464462752 11.6649831,0.182742901 C11.4822167,0.753823257 11.0939027,1.23352044 10.5837601,1.53806851 C11.0786917,1.48479486 11.5583889,1.34770839 12,1.15737171 C11.6650299,1.64466267 11.2462236,2.07865656 10.7665264,2.42893136 Z"
                  id="Path"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export function Voice() {
  return (
    <svg
      width="25px"
      height="36px"
      viewBox="0 0 25 36"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <title>Voice</title>
      <g
        id="VertexAiPage"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="VertexAILanding"
          transform="translate(-906.000000, -944.000000)"
          fill="#FFFFFF"
          fillRule="nonzero"
        >
          <g id="Group-4" transform="translate(87.000000, 171.000000)">
            <g id="Group-8" transform="translate(0.000000, 509.000000)">
              <g id="Group-7-Copy" transform="translate(672.000000, 0.000000)">
                <path
                  d="M159.375,288.75 C163.103672,288.75 166.125,285.728672 166.125,282 L160.5,282 C159.88125,282 159.375,281.49375 159.375,280.875 C159.375,280.25625 159.88125,279.75 160.5,279.75 L166.125,279.75 L166.125,277.5 L160.5,277.5 C159.88125,277.5 159.375,276.99375 159.375,276.375 C159.375,275.75625 159.88125,275.25 160.5,275.25 L166.125,275.25 L166.125,272.936719 L160.5,272.936719 C159.878719,272.936719 159.375,272.433 159.375,271.811719 C159.375,271.190437 159.878719,270.686719 160.5,270.686719 L166.125,270.75 C166.125,267.021328 163.103672,264 159.375,264 C155.646328,264 152.625,267.021328 152.625,270.75 L152.625,282 C152.625,285.726562 155.585156,288.75 159.375,288.75 Z M170.0625,277.5 C169.127344,277.5 168.375,278.252344 168.375,279.124219 L168.375,282 C168.375,287.156016 164.017734,291.309375 158.791406,290.978906 C154.145156,290.685773 150.375,286.296797 150.375,281.641406 L150.375,279.124219 C150.375,278.252344 149.619141,277.5 148.6875,277.5 C147.755859,277.5 147,278.252344 147,279.124219 L147,281.384766 C147,287.688984 151.497891,293.309766 157.6875,294.160547 L157.6875,296.625 L154.875,296.625 C153.596016,296.625 152.565937,297.692344 152.627813,298.985391 C152.655234,299.564062 153.173438,300 153.75,300 L165,300 C165.578109,300 166.094766,299.562937 166.122187,298.985391 C166.18125,297.69375 165.154687,296.625 163.875,296.625 L161.0625,296.625 L161.0625,294.250547 C167.088281,293.425781 171.75,288.250781 171.75,282 L171.75,279.124219 C171.75,278.252344 170.997656,277.5 170.0625,277.5 Z"
                  id="Shape"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
export function Play() {
  return (
    <svg
      width="22px"
      height="24px"
      viewBox="0 0 22 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <title>Play</title>
      <g
        id="VertexAiPage"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="VertexAILanding"
          transform="translate(-167.000000, -455.000000)"
          fill="#FFFFFF"
          fillRule="nonzero"
        >
          <g id="Group-4" transform="translate(87.000000, 171.000000)">
            <g id="Group-15" transform="translate(36.000000, 36.000000)">
              <g id="Bubble-1" transform="translate(0.000000, 221.000000)">
                <g id="Group-12" transform="translate(20.000000, 7.000000)">
                  <path
                    d="M24.1026791,41.6477137 L24.1026791,22.3520042 C24.1026791,20.9015631 25.6607412,19.9846209 26.928743,20.6886941 L44.3044432,30.336479 C45.6097145,31.061211 45.6097145,32.9383673 44.3044432,33.6630992 L26.928743,43.3110238 C25.6607412,44.0152366 24.1026791,43.0981547 24.1026791,41.6477137 Z"
                    id="Path"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
